import { BookingDetails } from '@/stores/useExploreStore';
import { BookingStep } from '../BookingModal';

export const getDisabledState = (
  booking: BookingDetails,
  step: BookingStep,
  userHasPaymentMethod: boolean,
  isAddressValid?: boolean,
) => {
  if (step === BookingStep.Calendar) {
    return !booking.selectedDate || !booking.selectedTime;
  }
  if (step === BookingStep.Address) {
    return !isAddressValid;
  }
  if (step === BookingStep.Details) {
    return !booking.reason;
  }
  if (step === BookingStep.Summary) {
    return !userHasPaymentMethod;
  }
  return false;
};
